import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SectionLabel } from '../shared/SurfaceParts';
import styles from '../ControlBridge.module.css';
import type { McEngineeringWorkspacesModel } from './mcEngineeringWorkspaces';

export interface EngineeringWorkspacesPanelProps {
  model: McEngineeringWorkspacesModel;
  compact?: boolean;
  onOpenWorkspace?: (slug: string) => void;
}

export const EngineeringWorkspacesPanel: React.FC<EngineeringWorkspacesPanelProps> = ({
  model,
  compact = false,
  onOpenWorkspace,
}) => {
  const navigate = useNavigate();

  if (compact || !model.links.length) return null;

  const openWorkspace = (slug: string) => {
    if (onOpenWorkspace) {
      onOpenWorkspace(slug);
      return;
    }
    navigate(`/render/${encodeURIComponent(slug)}/control-bridge`);
  };

  return (
    <section
      className={styles.mcEngineeringPanel}
      aria-label="Product engineering workspaces"
      data-testid="mc-engineering-workspaces"
    >
      <SectionLabel>Product engineering workspaces</SectionLabel>
      <ul className={styles.mcEngineeringList}>
        {model.links.map((link) => (
          <li key={link.supplyItemRef} className={styles.mcEngineeringRow}>
            <div className={styles.mcEngineeringMeta}>
              <span className={styles.mcEngineeringName}>{link.displayName}</span>
              {link.roleSummary ? (
                <span className={styles.mcEngineeringRole}>{link.roleSummary}</span>
              ) : null}
            </div>
            <button
              type="button"
              className={styles.mcEngineeringOpenBtn}
              disabled={!link.reachable}
              title={link.reachable ? undefined : link.unreachableReason ?? 'Unavailable'}
              onClick={() => openWorkspace(link.engineeringWorkspaceSlug)}
            >
              Open CB →
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};
